import React from "react";
import Grid from "../Grid";
import ChartCard from "../Card/ChartCard";
import ColumnChart from "../Chart/ColumnChart";
import AreaChart from "../Chart/AreaChart";
import { can_visit, numberWithCommas } from "../../helpers";
import Skeleton from "react-loading-skeleton";
import Spacing from "../Spacing";

export default function OverViewSection2({
  patientEncounterCount,
  encounterAmountPaidAverage,
  patientEncounterCountMonthWise,
  encounterAmountPaidMonthWise,
  patientEncounterChargeSubmitted,
}) {

  return (
    <Grid
      variant={`docpro_grid_gap_20 ${
        can_visit('dashboard_chart_payment_received') ? "docpro_grid_col_2 dashboard_chart" : "docpro_grid_col_1"
      }`}
    >
      {can_visit('dashboard_chart_claim_submitted')  && (
        <div>
          <ChartCard
            headingData={[
              {
                number: numberWithCommas(
                  patientEncounterCount ? patientEncounterCount : 0
                ),
                incresedNumber: "",
                title: "Claims submitted in the last 12 months",
              },
            ]}
            selectBox={true}
          >
            {(patientEncounterCountMonthWise?.length > 0) ? (
              <ColumnChart
                patientEncounterCountMonthWise={patientEncounterCountMonthWise}
              />
            ) : (
              <>
                <Spacing lg="10" sm="10" />
                <Skeleton width="100%" height="18rem" borderRadius="8px"></Skeleton>
              </>
            )}
          </ChartCard>
        </div>
      )}
      {can_visit('dashboard_chart_payment_received')  && (
        <ChartCard
          headingData={[
            {
              number: `$${numberWithCommas(
                patientEncounterChargeSubmitted ? patientEncounterChargeSubmitted : 0
              )}`,
              incresedNumber: "",
              title: "Payments received in the last 12 months",
            },
            {
              number: `$${numberWithCommas(
                encounterAmountPaidAverage ? encounterAmountPaidAverage : 0
              )}`,
              title: "Avg. payment per patient encounter this year",
              href: "/averate-revenue-per-encounter",
            },
          ]}
          selectBox={false}
          tooltip={true}
        >
          {(encounterAmountPaidMonthWise?.length > 0) ? (
            <AreaChart
              encounterAmountPaidMonthWise={encounterAmountPaidMonthWise}
            />
          ) : (
            <>
              <Spacing lg="10" sm="10" />
              <Skeleton width="100%" height="18rem" borderRadius="8px"></Skeleton>
            </>
          )}
        </ChartCard>
      )}
    </Grid>
  );
}
